import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase-client';

export default function ConfirmChildMentoring() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState('');
  const teamId = searchParams.get('teamId') || '';
  const childId = searchParams.get('childId') || '';

  const confirm = async () => {
    setBusy(true);
    setError('');
    try {
      const fn = httpsCallable(functions, 'confirmMentoringChildApplication');
      await fn({ teamId, childId });
      setConfirmed(true);
    } catch (err) {
      setError(err?.message || 'Could not confirm this application.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="search-page">
      <div className="card">
        <div className="card-body">
          <h1>Confirm mentoring application</h1>
          {confirmed ? (
            <>
              <p>The application is confirmed and can now be reviewed by the club’s mentoring administrators.</p>
              <button type="button" className="button button-primary" onClick={() => navigate('/dashboard')}>Return to dashboard</button>
            </>
          ) : (
            <>
              <p>
                Confirm that you consent to this child account participating in the club’s mentoring programme.
                Linked parents will be able to view mentoring conversations and guided check-in responses.
              </p>
              {error && <p className="text-danger" role="alert">{error}</p>}
              <button type="button" className="button button-primary" onClick={confirm} disabled={busy || !teamId || !childId}>
                {busy ? 'Confirming…' : 'Confirm application'}
              </button>
            </>
          )}
        </div>
      </div>
    </main>
  );
}
